import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../Link';
import { LocalizationContext } from '../../../hoc/Localization';
import styles from './styles.less';

const IconCard = ({ icon, title, text, search }) => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <img className={styles.skillImage} src={icon} alt="skill" />
      </div>
      <div>
        <h4>{title}</h4>
        <p>{text}</p>
        <Link className={styles.link} route="search" queryParams={{ search }}>
          {t('path.skills.courses')}
          <img style={{ marginLeft: '5px' }} src="/static/images/path/arrow.svg" alt="arrow" />
        </Link>
      </div>
    </div>
  );
};

IconCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
};

export default IconCard;
